import { Component, EventEmitter, inject, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { SystemCheckComponent } from '@components/system-check/system-check.component';
import { Session } from '@models/session';
import { FaceTracker } from '@services/face-tracker';
import { TranslateModule } from '@ngx-translate/core';
import { IconDirective } from '../../directives/icon.directive';
import { SystemCheckComponent as SystemCheckComponent_1 } from '../system-check/system-check.component';

@Component({
  selector: 'lv-verify-system',
  styleUrls: ['verify-system.component.scss'],
  templateUrl: 'verify-system.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule, IconDirective, SystemCheckComponent_1]
})
export class VerifySystemComponent {
  private faceTracker = inject(FaceTracker);

  @ViewChild(SystemCheckComponent, { static: true }) systemCheck: SystemCheckComponent;
  @Input() session: Session;
  @Output() next = new EventEmitter();

  webcamOk = false;
  websocketsOk = false;

  done() {
    this.faceTracker.initialize();
    this.next.emit();
  }
}
